import React from "react";
import { Button, Flex, ModalV2, QueryLoader, Text } from "@jsq/ds/core";
import { useGpPositionDetailsForCaseQuery } from "../../../../graphql/supergraphHooks";
import { PositionName } from "../../../common/PositionName";
import { positionRow, positionTable, positionTableHeader } from "./styles_vanilla.css";

export const PositionDetailModal = ({
  show,
  onHide,
  arenaId,
  caseId,
  profileName,
}: {
  show: boolean;
  onHide: () => void;
  arenaId?: number;
  caseId?: number;
  profileName: string;
}) => {
  const positionsResult = useGpPositionDetailsForCaseQuery({
    variables: { arenaId: arenaId ?? 0, caseId: caseId ?? 0 },
    skip: !caseId || !arenaId,
    fetchPolicy: "cache-and-network",
  });

  const positions = positionsResult?.data?.caseLinkedPositions ?? [];

  return (
    <ModalV2
      show={show}
      onHide={onHide}
      title="Affected positions"
      description={profileName}
      size="medium"
    >
      <ModalV2.Body>
        <QueryLoader result={positionsResult}>
          <div className={positionTable}>
            <div className={positionTableHeader}>
              <Text variant="strong-md">Position</Text>
            </div>
            {positions.map((position) => (
              <PositionName
                key={position.positionId}
                className={positionRow}
                account={position.profileName ?? profileName}
                entity={position.entityName ?? ""}
              />
            ))}
          </div>
        </QueryLoader>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end">
          <Button variant="neutral" onClick={onHide}>
            Close
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
